import { ReactNode, FC } from 'react';

import { VSpacing } from '@hh.ru/magritte-ui';

import FilterWrapper from 'src/components/Search/Common/Filters/FilterWrapper';
import { useApplyFilter } from 'src/components/Search/Common/Filters/hooks/useApplyFilter';
import OnlyWithCheckbox from 'src/components/Search/Resume/Filters/OnlyWithCheckbox';
import { useSelector } from 'src/hooks/useSelector';
import { EMPTY_RANGE_CLUSTER } from 'src/models/search/common/clusters';
import { ClusterKey } from 'src/types/search/common/clusters';

import Chart from 'src/components/Search/Resume/Filters/FilterWithChart/Chart';
import InputsGroup from 'src/components/Search/Resume/Filters/FilterWithChart/InputsGroup';
import { FilterRangeTrls } from 'src/components/Search/Resume/Filters/FilterWithChart/types';

interface FilterWithChartProps {
    title: ReactNode;
    name: typeof ClusterKey.Salary | typeof ClusterKey.Age;
    titleSideElement?: ReactNode;
    unitTitle?: ReactNode;
    emptyMessage?: string;
    trls: FilterRangeTrls;
}

const FilterWithChart: FC<FilterWithChartProps> = ({
    title,
    name,
    titleSideElement,
    trls,
    unitTitle = '',
    emptyMessage = '',
}) => {
    const applyFilter = useApplyFilter(name);

    const groups = useSelector((state) => state.searchClusters[name].groups);
    const selectedValues = useSelector((state) => state.searchClusters[name].selectedValues);

    return (
        <FilterWrapper filterKey={name} title={title} titleSideElement={titleSideElement}>
            <Chart
                groups={groups}
                selectedValues={selectedValues}
                applyFilter={applyFilter}
                trlsTitles={trls}
                unitTitle={unitTitle}
                emptyMessage={emptyMessage}
            />
            <VSpacing default={12} />
            <InputsGroup values={selectedValues} applyFilter={applyFilter} name={name} trls={trls} />
            <VSpacing default={12} />
            <OnlyWithCheckbox
                values={selectedValues}
                onChange={applyFilter}
                name={name}
                title={trls.onlyWithTitle}
                onReset={() => applyFilter(EMPTY_RANGE_CLUSTER.selectedValues)}
            />
        </FilterWrapper>
    );
};

export default FilterWithChart;
